import React, { useEffect } from 'react';
import SEO from './SEO';

const TermsOfService: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="pt-32 pb-20 container mx-auto px-6 max-w-4xl">
            <SEO
                title="Terms of Service"
                description="Terms and conditions for using OmniView Labs platforms and services."
                canonical="/terms"
            />
            <h1 className="text-4xl font-black text-[#021226] mb-8">Terms of Service</h1>
            <div className="prose prose-lg text-slate-600">
                <p className="mb-4">Last updated: February 03, 2026</p>
                <p className="mb-6">Please read these Terms of Service custom carefully before using the OmniView Labs website and services.</p>

                <h2 className="text-2xl font-bold text-[#021226] mt-8 mb-4">1. Acceptance of Terms</h2>
                <p className="mb-4">By accessing or using our service, you agree to be bound by these Terms. If you disagree with any part of the terms, then you may not access the service.</p>

                <h2 className="text-2xl font-bold text-[#021226] mt-8 mb-4">2. Use License</h2>
                <p className="mb-4">Permission is granted to temporarily download one copy of the materials (information or software) on OmniView Labs' website for personal, non-commercial transitory viewing only.</p>

                <h2 className="text-2xl font-bold text-[#021226] mt-8 mb-4">3. Disclaimer</h2>
                <p className="mb-4">The materials on OmniView Labs' website are provided on an 'as is' basis. OmniView Labs makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties.</p>
            </div>
        </div>
    );
};

export default TermsOfService;
